var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Grid, GridColumn, Heading, Icon, List, ListItem, Modal, ModalProvider, ModalTrigger, Table, Text, Tooltip, TooltipToggle } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { MandateType } from '../../config/mandate';
import { injectStores } from '../../util/StoresUtil';
import { format } from 'date-fns';
let RepresentationRightsMandatesModal = class RepresentationRightsMandatesModal extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate } = this.translateStore;
        const { type, children } = this.props;
        return (React.createElement(ModalProvider, null,
            React.createElement(ModalTrigger, null, children),
            React.createElement(Modal, { size: "6-col" },
                React.createElement(Text, null,
                    React.createElement(Heading, { className: "h3" }, translate('personPowers.mandatesModal.title')),
                    React.createElement(Grid, { align: ['between-xs'], className: "text__margin-double" },
                        React.createElement(GridColumn, { width: ['min'] },
                            React.createElement(Icon, { modifiers: "#file-edit", size: "lg" })),
                        React.createElement(GridColumn, { width: ['max'] },
                            React.createElement("p", { className: "text-small text-light" }, translate(`personPowers.mandatesModal.person.${type}`)),
                            React.createElement(List, { bordered: true, direction: "inline", type: "unstyled" },
                                React.createElement(ListItem, null,
                                    React.createElement("span", { className: "text-bold" }, this.props.mandate.getName()))))),
                    React.createElement(Table, { responsive: "cols", break: "sm" },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, translate('personPowers.mandatesModal.mandateType')),
                                React.createElement("th", null, translate('personPowers.mandatesModal.validUntil')))),
                        React.createElement("tbody", null, this.buildMandateRowsForRendering()))))));
    }
    buildMandateRowsForRendering() {
        const { mandate } = this.props;
        return mandate.getVisibleMandates().map((m, index) => this.buildMandateRowForRendering(m, index));
    }
    buildMandateRowForRendering(mandate, index) {
        const { translate } = this.translateStore;
        return (React.createElement("tr", { key: index },
            mandate.type === MandateType.LEGAL ? this.renderWithoutTooltip(mandate) : this.renderWithTooltip(mandate),
            React.createElement("td", null, (mandate.validUntil && format(new Date(mandate.validUntil), 'dd.MM.yyyy')) || translate('personPowers.mandate.unlimitedValidity'))));
    }
    renderWithTooltip(mandate) {
        const { translate } = this.translateStore;
        return (React.createElement("td", null,
            React.createElement(Tooltip, { referenceElement: React.createElement(TooltipToggle, { id: `mandates-modal-tooltip-${mandate.type}` }, translate(`personPowers.mandate.type.${mandate.type}`)) }, translate(`personPowers.mandate.type.${mandate.type}-tooltip`))));
    }
    renderWithoutTooltip(mandate) {
        const { translate } = this.translateStore;
        return React.createElement("td", null, translate(`personPowers.mandate.type.${mandate.type}`));
    }
};
RepresentationRightsMandatesModal = __decorate([
    injectStores,
    observer
], RepresentationRightsMandatesModal);
export default RepresentationRightsMandatesModal;
